module.exports = __webpack_public_path__ + "static/img/li_top5.aaa5827.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top5.png
// module id = ZxTG
// module chunks = 1